module.exports = __webpack_public_path__ + "static/media/user-4.1e09da48.jpg";